<template>
  <!--
        作者：gmshop
        时间：2020-06-08
        描述：超链接选择-页面
    -->
    <el-select v-model="activePage" placeholder="请选择" class="percent-w100" @change="changeFunc" value-key="url">
        <el-option v-for="item in pages" :key="item.url" :value-key="item.name" :label="item.name" :value="item"></el-option>
    </el-select>
</template>

<script>
    export default{
        data(){
            return {
                /*页面数据*/
                pages: [
                    {
                        url: 'pages/index/index',
                        name: '首页',
                        type: '页面'
                    },
                    {
                        url: 'pages/product/category',
                        name: '分类',
                        type: '页面'
                    },
                    {
                        url: 'pages/cart/cart',
                        name: '购物车',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/index/index',
                        name: '我的',
                        type: '页面',
                    },

                    {
                        url: 'pages/study/study',
                        name: '有易读书会',
                        type: '页面',
                    },

                    {
                        url: 'pages/user/my-wallet/widthdrawlist',
                        name: '余额提现记录',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/my-wallet/widthdraw',
                        name: '余额提现',
                        type: '页面',
                    },
                    {
                        url: 'packageA/plus/transfer/balance/balance',
                        name: '余额转账',
                        type: '页面',
                    },
                    {
                        url: 'pages/agent/index/index',
                        name: '分销中心',
                        type: '页面',
                    },
                    {
                        url: 'pages/agent/index/apply',
                        name: '加入推广',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/address/address',
                        name: '收货地址',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/set/set',
                        name: '设置',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/my-coupon/my-coupon',
                        name: '我的优惠券',
                        type: '页面',
                    },
                    {
                        url: 'pages/article/list/list',
                        name: '文章首页',
                        type: '页面',
                    },
                    // {
                    //     url: 'pages/upgrade/upgrade',
                    //     name: '我要升级',
                    //     type: '页面',
                    // },
                    {
                        url: 'pages/product/consumption',
                        name: '快速下单',
                        type: '页面',
                    },
                    // {
                    //     url: 'pages/user/apply/apply',
                    //     name: '会员升级申请',
                    //     type: '页面',
                    // },
                    // {
                    //     url: 'pages/user/apply/index',
                    //     name: '升级申请列表',
                    //     type: '页面',
                    // },
                    // {
                    //     url: 'pages/user/my-store/apply/apply',
                    //     name: '门店申请',
                    //     type: '页面',
                    // },
                    // {
                    //     url: 'pages/user/my-store/apply/index',
                    //     name: '门店申请列表',
                    //     type: '页面',
                    // },
                    // {
                    //     url: 'pages/order/store-order/myorder',
                    //     name: '门店订单列表',
                    //     type: '页面',
                    // },
                    // {
                    //     url: 'packageA/reservation/list/list',
                    //     name: '预约服务',
                    //     type: '页面',
                    // },
                    {
                        url: 'packageA/customization/my-customization-order',
                        name: '我的定制订单',
                        type: '页面',
                    },
                    {
                        url: 'packageA/sauce/index',
                        name: '商品定制',
                        type: '页面',
                    },
                    {
                        url: 'pages/agent/qrcode/qrcode',
                        name: '推广二维码',
                        type: '页面',
                    },
                    // fzf
                      {
                          url: 'pages/order/order-pg',
                          name: '会员充值卡',
                          type: '页面',
                      },
                      {
                          url: 'pages/order/order-exchange-pg',
                          name: '兑换中心',
                          type: '页面',
                      },
                      // {
                      //     url: 'pages/index/index618',
                      //     name: '618活动',
                      //     type: '页面',
                      // },
                      {
                          url: 'pages/index/indexcourse',
                          name: '线上课程',
                          type: '页面',
                      },

                      {
                          url: 'pages/user/customer/customer',
                          name: '我的-客户分析',
                          type: '页面',
                      },
                      {
                          url: 'pages/user/team/team',
                          name: '我的-我的团队',
                          type: '页面',
                      },

                      {
                          url: 'pages/login/enroll',
                          name: '我的-预约报名',
                          type: '页面',
                      },
                      {
                          url: 'pages/user/apply/applyc',
                          name: '课程活动:申请推荐官',
                          type: '页面',
                      },

                      // {
                      //     url: 'packageA/video/swiper',
                      //     name: '视频中心',
                      //     type: '页面',
                      // },
                      // {
                      //     url: 'pages/cart/cartPg?grade_id=2',
                      //     name: '推荐官大礼包',
                      //     type: '页面',
                      // },
                      // {
                      //     url: 'pages/cart/cartPg?grade_id=4',
                      //     name: '运营官大礼包',
                      //     type: '页面',
                      // },

                    // {
                    //     url: 'packageA/plus/gradecard/index',
                    //     name: '会员卡激活',
                    //     type: '页面',
                    // },
                    // {
                    //     url: 'packageA/user/contacts/list',
                    //     name: '我的联系人',
                    //     type: '页面',
                    // },
                    // {
                    //     url: 'pages/user/invite/invite',
                    //     name: '邀请有礼',
                    //     type: '页面',
                    // },
                    // {
                    //     url: 'packageA/user/gcard/list',
                    //     name: '我的卡券',
                    //     type: '页面',
                    // },
                    // {
                    //     url: 'pages/user/my-bargain/my-bargain',
                    //     name: '我的砍价',
                    //     type: '页面',
                    // },
                    // {
                    //     url: 'pages/order/member-card',
                    //     name: '会员卡',
                    //     type: '页面',
                    // },
                    // {
                    //     url: 'packageA/fapiao/index/index',
                    //     name: '发票管理',
                    //     type: '页面',
                    // },
                ],
                detect: [
                  {
                      auth: '/pages/upgrade/upgrade',
                      url: [
                        'pages/upgrade/upgrade',
                      ],
                      name: '我要升级',
                  },
                  {
                      auth: '/user/review/index',
                      url: [
                        'pages/user/apply/apply',
                        'pages/user/apply/index',
                      ],
                      name: '会员升级申请',
                  },
                  {
                      auth: '/store/review/index',
                      url: [
                        'pages/user/my-store/apply/apply',
                        'pages/user/my-store/apply/index',
                      ],
                      name: '门店申请',
                  },
                  {
                      auth: '/customization/order/index',
                      url: [
                        'packageA/customization/my-customization-order',
                        'packageA/sauce/index',
                      ],
                      name: '定制订单',
                  },
                  {
                      auth: '/plus/gradecard/index',
                      url: [
                        'packageA/plus/gradecard/index',
                      ],
                      name: '会员卡激活',
                  },
                  {
                      auth: '/gcard',
                      url: [
                        'packageA/user/gcard/list',
                      ],
                      name: '我的卡券',
                  },
                  {
                      auth: '/plus/bargain/index',
                      url: [
                        'pages/user/my-bargain/my-bargain',
                      ],
                      name: '我的砍价',
                  },
                  {
                      auth: '/plus/userupgrade/memberCard',
                      url: [
                        'pages/order/member-card',
                      ],
                      name: '会员卡',
                  },
                  {
                      auth: '/plus/invitation/index',
                      url: [
                        'pages/user/invite/invite',
                      ],
                      name: '邀请有礼',
                  },


                ],
                /*选中的值*/
                activePage: '首页'
            }
        },
        created() {
          /*是否授权*/
          this.detect.forEach(item => {
            if(!this.$filter.isAuth(item.auth)){
              let arr = [];
              this.pages.forEach(item1 => {
                if(!item.url.includes(item1.url)){
                  arr.push(item1);
                }
                this.pages = arr;
              });
            }
          });
          /*初始化*/
          this.changeFunc(this.pages[0]);
        },
        methods: {
            /*选中的值*/
            changeFunc(e){
                this.$emit('changeData', e);
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/setlink/part/Pages.vue